import { Button } from "reactstrap";
import PageLayout from "../../../components/layout/page";
import { useAddUpdate } from "../../../helper/addUpdateHook";
import { useApi } from "../../../helper/apiHook";
import { AddUpdateCity } from "./addUpdate";
import { plus } from "../../../constant/icons";
import { columns } from "./columns";
import { DataView } from "../../../components/table/table";
import { useEffect } from "react";
import ModalView from "../../../components/modal";

export const CityApi = (paging?:boolean, dataLoad: any = {}) => {
  return { ...useApi("/cities",paging, undefined, dataLoad) };
};
export default function City() {
  const api = CityApi(true);
  const AddUpdate = useAddUpdate();
  useEffect(() => {
    api.mutate();
  }, []);
  return (
    <>
      <PageLayout
        item={
          <Button
            color="secondary"
            onClick={() =>
              AddUpdate.openAddEditFrom({
                name: "",
                stateId: "",
              })
            }
          >
            {plus.icon}Add New
          </Button>
        }
        View={
          <DataView
            columns={columns({
              api,
              openAddEditFrom: AddUpdate.openAddEditFrom,
            })}
            rows={api.data}
            currentPage={api.currentPage}
            rowCount={api.rowCount}
            limit={api.limit}
            updatePagination={api.updatePagination}
          />
        }
      />
      {AddUpdate.viewAddUpdate && (
        <ModalView
          modalView={AddUpdate.viewAddUpdate}
          modalName={AddUpdate.currentValue?.id ? "Edit City" : "Add City"}
          onModalDismiss={AddUpdate.closeAddEditFrom}
        >
          <AddUpdateCity
            closeAddUpdate={AddUpdate.closeAddEditFrom}
            api={api}
            value={AddUpdate.currentValue}
          />
        </ModalView>
      )}
    </>
  );
}
